<div class="d-flex justify-content-center align-items-center flex-column">
  <h3 class="text-center" [ngClass]="{'page-title': useRebrandedLayout }">Transfer of keepership</h3>
  <div *ngIf="title || subTitle || list" class="mt-3 w-75 alert alert-dark text-center">
    <p *ngIf="title" [innerHTML]="sanitizedTitle"></p>

    <ol *ngIf="list" class="d-flex align-items-center flex-column ordered-list fw-bold">
      <li *ngFor="let item of list">{{ item }}</li>
    </ol>

    <p *ngIf="subTitle">
      {{ subTitle }}
    </p>
  </div>
</div>
